import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ROUTES } from "../../app/utils/CONSTANTS";
import axios from "axios";

export const addCareerCardOtherDetails = createAsyncThunk(
  "careerCard/addOtherDetails",
  async (payload: any, { rejectWithValue }) => {
    try {
    
       const response: { success: boolean; data: any } = await axios({
        method: "post", 
        url: ROUTES.addCareerCardOtherDetails,
        data: payload,
        withCredentials:true
      });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const addCareerCardOtherDetailsSlice = createSlice({
  name: "addCareerCardOtherDetails",
  initialState: {
    status: "idle",
    error: null,
    data: null,
  } as {
    status: "idle" | "loading" | "succeeded" | "failed";
    error: string | null;
    data: any;
  },
  reducers: {
    resetaddCareerCardOtherDetails: (state) => {
        state.data= null;
        state.status= "idle";
        state.error= null;
    }},
  extraReducers: (builder) => {
    builder
      .addCase(addCareerCardOtherDetails.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addCareerCardOtherDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(addCareerCardOtherDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const { resetaddCareerCardOtherDetails } = addCareerCardOtherDetailsSlice.actions;

export default addCareerCardOtherDetailsSlice.reducer;
